import React, { useState, useEffect, useReducer } from 'react';
import './Teachers.css';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CommonModal from '../PopUp/PopupModal';
import { CSVTooltip } from '../Snippets/Snippets';
import { Modal } from '@material-ui/core';
import { apiPath, apiKey } from '../../constants';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));

function Teachers() {

    let fileReader;
    var userdata = JSON.parse(localStorage.getItem('kokos_userdata'))


    const [open, setOpen] = useState(false);
    const [teacher, setTeacher] = useState([]);
    const [loading, setLoading] = useState(true);
    const [emailstatus, setEmailStatus] = useState(true);
    const [usernamestatus, setUsernameStatus] = useState(true);
    const [popuomsg, setPopupmsg] = useState(false);
    // const [message, setMessage] = useState('');
    // const [msgstatus, setMsgstatus] = useState();
    const [phValidation, setPhValidation] = useState(false);
    const [coursename, setCoursename] = useState([]);
    const [courseDetailsArray, setCourseDetailsArray] = useState([]);
    const [selectedTeacherDetails, setSelectedTeacherDetails] = useState([]);
    const [editmsg, setEditmsg] = useState();
    const [isActive, editIsactive] = useState(true);
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [coursesDetailsarray, setCoursesDetailsarray] = useState([]);
    const [editcourseArray, setEditcourseArray] = useReducer(CourseArrayReducer, [])
    const [firstNameError, setFirstnameerror] = useState(false);
    const [lastnameError, setLastNameError] = useState(false);
    const [emailerror, setEmailError] = useState('');
    const [loadingbtn, setloadingBtn] = useState(false);
    const [loadingbtnrestart, setloadingBtnrestart] = useState(false);
    const [modalID, setModalID] = useState('');
    const [messagePopup, setMessagePopup] = useState('');
    let numberValidationStatus = true

    useEffect(() => {
        initalApiCallFetchTeachers();
    }, [])

    const initalApiCallFetchTeachers = () => {
        var user = JSON.parse(localStorage.getItem('kokos_userdata'));
        async function fetchTeachers() {
            const response = await fetch(apiPath + 'users/schools/' + user.school_code + '/roles/TCHR', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
            const data = await response.json();
            getAllCourses();
            setTeacher(data);
            setLoading(false);
        }
        fetchTeachers();
    }

    const handleClickOpen = () => {
        setOpen(true);
        // setModalSelection("1")
    };
    const handleClose = (e, reason) => {
        //checking reason to avoid closing modal close on backdropclick
        if (!(reason && reason == 'backdropClick')) setOpen(false);
    };

    const classes = useStyles();

    const srtingEmptyCheck = (strValue) => {
        return (!strValue.trim().length) ? false : true
    }

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const checkValidity = (FirstName, SecondName, UserName, Password, phoneNumber, Email) => {
        return (srtingEmptyCheck(FirstName) && srtingEmptyCheck(Email) && srtingEmptyCheck(SecondName) && srtingEmptyCheck(UserName) && srtingEmptyCheck(Password) && srtingEmptyCheck(phoneNumber)) ? true : false
    }

    const validateforms = () => {

        var FirstName = document.getElementById("fname").value;
        var SecondName = document.getElementById("sname").value;
        var Email = document.getElementById("email").value;
        var UserName = document.getElementById("uname").value;
        var Password = document.getElementById("password").value;
        var phoneNumber = document.getElementById("phoneno").value;



        if ((srtingEmptyCheck(UserName) === false)) {
            document.getElementById("uname_error").innerHTML = "<span style='color:red;'>Please enter a vaild username</span>";
        }
        // if ((srtingEmptyCheck(FirstName) === false) || (validateNameHasNumber(FirstName)===false)) {
        //     document.getElementById("fname_error").innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
        //     numberValidationStatus = false
        // }
        // else {
        //     document.getElementById("fname_error").innerHTML = "<span></span>";
        // }
        // if ((srtingEmptyCheck(SecondName) === false)|| (validateNameHasNumber(SecondName)===false)) {
        //     document.getElementById("sname_error").innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
        //     numberValidationStatus = false
        // }
        // else {
        //     document.getElementById("sname_error").innerHTML = "<span></span>";
        // }
        if (srtingEmptyCheck(Password) === false) {
            document.getElementById("pass_error").innerHTML = "<span style='color:red;'>Please enter a vaild password</span>";
        }
        else {
            document.getElementById("pass_error").innerHTML = "<span></span>";
        }

        if (numberValidationStatus && emailstatus && usernamestatus && phValidation && checkValidity(FirstName, SecondName, UserName, Password, phoneNumber, Email)) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                    "class_code": 'dummy',
                    "email": Email,
                    "first_name": FirstName,
                    "is_active": 1,
                    "last_name": SecondName,
                    "role_code": 'TCHR',
                    "username": UserName,
                    "contact_number": phoneNumber,
                    "password": Password,
                    "country_code": "India",
                    "language": "English"
                })
            };
            fetch(apiPath + 'users/schools/' + userdata.school_code + '/user', requestOptions)
                .then(response => response.json())
                .then(data => {
                    // console.log(data)
                    if (data.status === "success") {
                        setModalID(1)
                    } else {
                        setModalID(2)
                    }
                    handleClose()
                    setMessagePopup(data.message)
                    setPopupmsg(true);
                    initalApiCallFetchTeachers();

                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const togglePopUpOpen = (status, data) => {
        handleClose()
        setMessagePopup(data)
        setModalID(status)
        // setMsgstatus(status);
        // setMessage(data);
        setPopupmsg(true);
    }

    const togglePopUpClose = () => {
        setPopupmsg(false);
    }

    const changeHandler = (event) => {
        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(event.target.files[0])
    }

    const handleFileRead = (e) => {
        const content = fileReader.result;
        csvJSON(content)
    }

    const csvJSON = (csv) => {
        console.log(csv)
        const lines = csv.split('\n')
        const result = []
        const headers = lines[0].split(',')

        for (let i = 1; i < lines.length; i++) {
            if (!lines[i])
                continue
            const obj = {}

            const currentline = lines[i].split(',')
            for (let j = 0; j < headers.length; j++) {

                if (headers[j] == "is_active") {
                    obj[headers[j].trim()] = Number(currentline[j])
                } else {
                    obj[headers[j].trim()] = currentline[j]
                }
            }
            result.push(obj)
        }
        console.log(result)
        uploadCsvFunction(result)
    }

    const uploadCsvFunction = (data) => {
        console.log(data)
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify(data)
        };
        fetch(apiPath + 'users/schools/' + userdata.school_code + '/csv', requestOptions)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.status === "success") {
                    setModalID(1)
                } else {
                    setModalID(2)
                }
                handleClose()
                setMessagePopup(data.message)
                setPopupmsg(true);
                initalApiCallFetchTeachers();
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const emailCheck = (ID) => {
        if (validateEmail(ID) === false) {
            document.getElementById("email_error").innerHTML = "<span style='color:red;'>Please enter a vaild email id</span>";
            setEmailStatus(false)
        }
        else {
            document.getElementById("email_error").innerHTML = "<span></span>";
            var url = apiPath + 'users/schools/user/email/' + ID
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data)
                    if (data.status === "failed") {
                        setEmailStatus(false);
                        document.getElementById("email_error").innerHTML = "<span style='color:red;'>This email id already used</span>"
                    } else {
                        setEmailStatus(true);
                        document.getElementById("email_error").innerHTML = "<span style='color:red;'></span>"
                    }
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const UsernameCheck = (username) => {
        if (srtingEmptyCheck(username) === false) {
            document.getElementById("uname_error").innerHTML = "<span style='color:red;'>Please enter a vaild user name</span>";
            setUsernameStatus(false)
        }
        else {
            document.getElementById("uname_error").innerHTML = "<span></span>";
            var url = apiPath + 'users/schools/user/username/' + username
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data)
                    if (data.status === "failed") {
                        setUsernameStatus(false)
                        document.getElementById("uname_error").innerHTML = "<span style='color:red;'>This username already used</span>"
                    } else {
                        setUsernameStatus(true)
                        document.getElementById("uname_error").innerHTML = "<span style='color:red;'></span>"
                    }
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const phonenoValidation = (phonenumber) => {
        const regex = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        if (regex.test(phonenumber) === false) {
            setPhValidation(false)
            document.getElementById("phone_error").innerHTML = "<span style='color:red;'>Please enter a vaild phone number</span>";
        }
        else {
            setPhValidation(true)
            document.getElementById("phone_error").innerHTML = "<span></span>";
        }
    }

    const handleEditTeachersOpen = (teacherDetails) => {
        setEditmsg(true)
        setSelectedTeacherDetails(teacherDetails)
        setFirstname(teacherDetails.first_name)
        setLastname(teacherDetails.last_name)
        setEmail(teacherDetails.email)
        if (teacherDetails.is_active === 1) {
            editIsactive(true)
        }
        else {
            editIsactive(false)
        }
        courseComparision(teacherDetails.courses);
    }

    const courseComparision = (assignedCourses) => {
        var newArray = [];
        var allCoursesDetails = courseDetailsArray.slice(0);

        if (assignedCourses === null) {
            for (var i = 0; i < allCoursesDetails.length; i++) {
                newArray[i] = { course: coursename[i], flag: 0, course_code: allCoursesDetails[i].course_code }
            }
        } else {
            var assigCourseforTeacher = Object.values(assignedCourses);
            for (var j = 0; j < allCoursesDetails.length; j++) {
                var courseCode = allCoursesDetails[j].course_code
                if (assigCourseforTeacher.includes(courseCode)) {
                    newArray[j] = { course: coursename[j], flag: 1, course_code: allCoursesDetails[j].course_code }
                } else {
                    newArray[j] = { course: coursename[j], flag: 0, course_code: allCoursesDetails[j].course_code }
                }
            }
        }
        setCoursesDetailsarray(newArray)
    }

    const getAllCourses = () => {
        var url = apiPath + 'courses/schools/' + userdata.school_code
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                modifyCoursename(data);
                setCourseDetailsArray(data);
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const modifyCoursename = (courseDetails) => {
        var modCourseArray = [];
        for (var i = 0; i < courseDetails.length; i++) {
            var orgStr = courseDetails[i].course_code;
            var strArray = orgStr.split('+');
            var reCharacter = strArray[1].replace('-', ' ')
            modCourseArray.push(reCharacter)
        }
        setCoursename(modCourseArray);
    }

    const editTeachersDetailsApiCall = () => {
        if (emailerror.length === 0 && !firstNameError && !lastnameError) {
            setloadingBtn(true)
            var active
            var newCourseArray = {}
            var removedCourseArray = {}
            if (isActive === true) {
                active = '1'
            } else {
                active = '0'
            }
            for (var i = 0; i < coursesDetailsarray.length; i++) {
                if (coursesDetailsarray[i].flag === 1) {
                    newCourseArray[i] = coursesDetailsarray[i].course_code
                } else {
                    removedCourseArray[i] = coursesDetailsarray[i].course_code
                }
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                    "user_code": selectedTeacherDetails.user_id,
                    "first_name": firstname,
                    "last_name": lastname,
                    "email": email,
                    "is_active": active,
                    "role_code": "TCHR",
                    "enrolled_course_code": newCourseArray,
                    "unenrolled_course_code": removedCourseArray
                })
            };
            fetch(apiPath + 'users/schools/' + userdata.school_code + '/user/' + selectedTeacherDetails.username + '/teacher/update', requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                        //setModalID(1)
                    } else {
                        togglePopUpOpen(2, data.message)
                        //setModalID(2)
                    }
                    setMessagePopup(data.message)
                    setPopupmsg(true);
                    setEditmsg(false);
                    initalApiCallFetchTeachers();
                    setloadingBtn(false)
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const viewSingleTeacher = (username) => {
        setLoading(true)
        var url = apiPath + 'users/schools/' + userdata.school_code + '/user/' + username
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false)
                // console.log(data)
                // setSingleTeacher(data)
                // togglePopUpOpen(3, "Teacher Details")
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const toggleisActiveSwitch = () => {
        editIsactive(!isActive)
    }

    const closeEditModal = () => {
        setEditmsg(false)
        setFirstnameerror(false)
        setLastNameError(false)
        setEmailError('')
    }

    const handleAddCourse = (course_code) => {
        setEditcourseArray({ course_code, type: 'add' })
    }

    const handleRemoveCourse = (course_code) => {
        setEditcourseArray({ course_code, type: 'remove' })
    }

    function CourseArrayReducer(state, action) {
        switch (action.type) {
            case 'add':
                var newArray = [];
                newArray = coursesDetailsarray;
                let aindex = courseDetailsArray.findIndex(item => item.course_code === action.course_code);
                newArray[aindex].flag = 1;
                setCoursesDetailsarray(newArray);
                return [...state, coursesDetailsarray];
            case 'remove':
                var newArrayrmv = [];
                newArrayrmv = coursesDetailsarray;
                let index = courseDetailsArray.findIndex(item => item.course_code === action.course_code);
                newArrayrmv[index].flag = 0;
                setCoursesDetailsarray(newArrayrmv);
                return [...state, coursesDetailsarray];
            default:
                return state;
        }
    }

    const resetPassword = () => {
        setloadingBtnrestart(true)
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify({
            })
        };
        fetch(apiPath + 'users/schools/' + userdata.school_code + '/user/' + selectedTeacherDetails.username + '/resetpassword', requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    togglePopUpOpen(1, data.message + '\n The new password is: ' + data.new_password)
                } else {
                    togglePopUpOpen(2, data.message)
                }
                setloadingBtnrestart(false)
                setEditmsg(false)
                initalApiCallFetchTeachers();
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const firstNameCheck = (event) => {
        var hasNumber = /^[a-zA-Z\s]*$/;

        if (firstname.length !== 0 && hasNumber.test(firstname) === true) {
            if (!firstname.replace(/\s/g, '').length) {
                setFirstnameerror(true)
            }
            else { setFirstnameerror(false) }
        } else {
            setFirstnameerror(true)
        }

    }

    const NameCheck = (event) => {
        var hasNumber = /^[a-zA-Z\s]*$/;
        if (!lastname.replace(/\s/g, '').length) {
            setLastNameError(false)
        }
        if (lastname.length !== 0 && hasNumber.test(lastname) === true) {
            if (!lastname.replace(/\s/g, '').length) {
                setLastNameError(true)
            }
            else { setLastNameError(false) }

        } else {
            setLastNameError(true)
        }
    }

    const validateNameHasNumber = (name) => {
        let hasNumber = /^[a-zA-Z\s]*$/;
        if (hasNumber.test(name) === false) {
            return false
        }
        else {
            return true
        }
    }

    const checkEmailValidity = (event) => {
        if (email.length === 0) {
            setEmailError('*Please enter a valid email Id')
        }
        if (validateEmail(email) === false) {
            setEmailError('*Please enter a vaild email Id')
        } else {
            setEmailError('')
        }
        if (email.length !== 0 && selectedTeacherDetails.email !== email && validateEmail(email) === true) {
            var url = apiPath + 'users/schools/user/email/' + email
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status == 'failed') {
                        setEmailError(data.message)
                    } else {
                        setEmailError('')
                    }

                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const restrictChars = (e) => {
        const value = e || window.event;
        const key = value.keyCode || value.which;
        if (key < 48 || key > 57 || key == 8 || key == 46) {
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }
    }

    const nameValidation = (field_id) => {
        let name = ''
        if (field_id === 'sname_error') {
            name = document.getElementById("sname").value;
        }
        else {
            name = document.getElementById("fname").value;
        }


        if ((srtingEmptyCheck(name) === false) || (validateNameHasNumber(name) === false)) {
            document.getElementById(field_id).innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
            numberValidationStatus = false
        }
        else {
            document.getElementById(field_id).innerHTML = "<span></span>";
        }
    }

    return (
        <div className="teachersmain">
            <div className="teachers_Button_Main">
                <div className="fileUpload Teachers_button_new">
                    <span>Load From csv</span>
                    <input id="csvfile" type="file" className="upload" accept='.csv' onChange={changeHandler} />
                </div>
                <CSVTooltip filetype={'teachers'} />
                <div className="Teachers_button_new" onClick={handleClickOpen}>
                    Add Teacher
                </div>
            </div>
            {
                loading ?
                    <img className="loadingSymbol" src={require('../../images/loading2.gif')} alt="loading" />
                    :
                    <table className="teachersTable">
                        <thead>
                            <tr>
                                <th className="teachTable_No">No.</th>
                                <th className="teachTable_Name">Name</th>
                                <th className="teachTable_Username">User Name</th>
                                <th className="teachTable_Email">Email Id</th>
                                <th className="teachTable_active">Active</th>
                                <th className="teachTable_courassign">Update Teacher</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                teacher && teacher.map((teacher_details, index) => {
                                    return (
                                        <tr key={teacher_details.user_id}>
                                            <td className="teachTable_No">{index + 1}</td>
                                            <td className="teachTable_Name">
                                                {teacher_details.first_name}&nbsp;	{teacher_details.last_name}</td>
                                            <td className="teachTable_Username">{teacher_details.username}</td>
                                            <td className="teachTable_Email">{teacher_details.email}</td>
                                            {
                                                teacher_details.is_active === 1 ?
                                                    <td className="teachTable_active">Yes</td> : <td>No</td>
                                            }
                                            <td className="teachTable_courassign"><div className="teachTable_assign"
                                                onClick={() => handleEditTeachersOpen(teacher_details)}
                                            >Edit</div></td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
            }
            <div>
                {
                    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                            Teacher Details
                        </DialogTitle>
                        <DialogContent dividers>
                            <form autoComplete="off" style={{ padding: '0vw 4vw' }}>
                                <input id="fname" className="input_teachers" type="text" placeholder="First Name"
                                    onBlur={e => nameValidation('fname_error')} />
                                <div className="fname_name" id='fname_error'></div>
                                <input id="sname" className="input_teachers" type="text" placeholder="Last Name"
                                    onBlur={e => nameValidation('sname_error')} />
                                <div className="sname_name" id='sname_error'></div>
                                <input id="email" className="input_teachers" type="text"
                                    placeholder="Email" onBlur={e => emailCheck(e.target.value)} />
                                <div className="sname_name" id='email_error'></div>
                                <input id="phoneno" onKeyPress={restrictChars} className="input_teachers" type="text" pattern="\d*" placeholder="Phone number"
                                    onBlur={e => phonenoValidation(e.target.value)} />
                                <div className="sname_name" id='phone_error'></div>
                                <input id="uname" className="input_teachers" type="text"
                                    onBlur={e => UsernameCheck(e.target.value)} placeholder="User Name" />
                                <div className="sname_name" id='uname_error'></div>
                                <input id="password" className="input_teachers" type="password" 
                                placeholder="Password" autoComplete="new-password"
                                onBlur={() => document.getElementById('pass_error').innerHTML = "<span></span>"}/>
                                <div className="sname_name" id='pass_error'></div>
                            </form>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={validateforms} color="primary">
                                Create
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </div>
            <div className={`editModalBackground editmodalShowing-${editmsg}`}>
                <div className="editmodal_close_img_div">
                    <img onClick={closeEditModal} className="editmodal_close" src={require('../../images/close.png')} />
                </div>
                <div className="editTeacherHeading">Edit Teacher Details</div>
                <div className="edit_resetpassword_outter">
                    {
                        isActive && isActive === true ?
                            <img className="edittogglebutton" onClick={() => toggleisActiveSwitch()} src={require('../../images/switch.png')} />
                            :
                            <img className="edittogglebutton" onClick={() => toggleisActiveSwitch()} src={require('../../images/switchoff.png')} />
                    }
                    <div className="editactive">
                        Active :
                    </div>
                </div>
                <div className="editModalBackground_outter">
                    <form autoComplete="off" className="edit_input_outter">
                        <div>
                            <div className="std_firstname_style">First Name :</div>
                            <input id="editfname" className="edit_input_teachers" type="text"
                                value={firstname} onChange={e => setFirstname(e.target.value)}
                                onBlur={e => firstNameCheck(e.target.value)} />
                        </div>
                        {firstNameError && <div className="emailwarningmessage">*Please enter valid first name</div>}
                        <div>
                            <div className="std_firstname_style">Last Name :</div>
                            <input id="editlname" className="edit_input_teachers" type="text"
                                value={lastname} onChange={e => setLastname(e.target.value)}
                                onBlur={e => NameCheck(e.target.value)}
                            />
                        </div>
                        {lastnameError && <div className="emailwarningmessage">*Please enter vaild last name</div>}
                        <div>
                            <div className="std_firstname_style">Email ID :</div>
                            <input id="editemail" className="edit_input_teachers" type="email"
                                value={email} onChange={e => setEmail(e.target.value)}
                                onBlur={e => checkEmailValidity(e.target.value)} />
                        </div>
                        <div className="emailwarningmessage">{emailerror}</div>
                        {
                            // <input id="editphoneno" className="edit_input_teachers" type="text" placeholder="Phone number"
                            // value={phoneno} onChange={e => setSelectedTeacherValues(e.target.value, 4)} />
                        }
                        <div className="edit_coursedetails_outter">
                            <div className="edit_coursedetails_heading">Courses</div>
                            <div className="edit_coursedetails_names">
                                {
                                    coursesDetailsarray.map((coursenames, index) => {
                                        return (
                                            <div className="edit_coursedetails_checkboxmain" key={index}>
                                                {
                                                    (coursenames.flag === 1) &&
                                                    <img className="edit_coursedetails_checkbox"
                                                        onClick={() => handleRemoveCourse(coursenames.course_code)}
                                                        src={require('../../images/tick.png')} alt="checked" />
                                                }
                                                {
                                                    (coursenames.flag === 0) &&
                                                    <img className="edit_coursedetails_checkbox" onClick={() => handleAddCourse(coursenames.course_code)} src={require('../../images/untick.png')} alt="checked" />
                                                }
                                                <div className="edit_coursedetails_coursename">
                                                    {
                                                        coursenames.course
                                                    }
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </form>
                </div>
                <div className="edit_resetpassword_outter">
                    {loadingbtnrestart ? <div className="edit_resetpassword_btn_restart_tech"><div className="loader">
                    </div></div> :
                        <div className="edit_resetpassword_btn" onClick={() => resetPassword()}>Reset Password</div>}
                    {loadingbtn ? <div className="edit_resetpassword_btn_loading"><div class="loader"></div></div> :
                        <div className="edit_resetpassword_btn" onClick={() => editTeachersDetailsApiCall()} >Update</div>}
                </div>
            </div>
            {popuomsg && <CommonModal message={messagePopup} msgstatus={modalID} popupstatus={popuomsg} setpopup={setPopupmsg} />}

        </div>
    );
}

export default Teachers;